import React from "react";
import {useTranslation} from "react-i18next";
import {Button, Image, Popup} from "semantic-ui-react";
import {getSubdomain} from "../config/StylesheetInjector";
import {animationsRegistry} from "../constants/animations";
import {useNavigationHandler} from "../contexts/Navigation";
import useFooterVisibility from "../hooks/useFooterVisibility";
import {useTrackSFOSteps} from "../react-query/Mutations";
import {useNavigate} from "react-router";

const style = {
    borderRadius: "10px",
    background: "#292F36",
    color: "#FFFFFF",
};

const Footer = () => {
    const navigate = useNavigate();
    const {
        currentStep,
        currentSection,
        currentSectionStep,
        continueDisabled,
        handleNext,
        handlePrev,
        isContinueBtnLoading,
        footerNextButtonText,
        handleFooterNextButtonText,
        disabledTooltip,
    } = useNavigationHandler();

    const {shouldHideFooter, shouldHideContinueButton, shouldHideBackButton} =
        useFooterVisibility();

    const {mutateAsync: trackSFOSteps, isPending} = useTrackSFOSteps();

    const {t} = useTranslation();
    let subDomain = getSubdomain();

    if (shouldHideFooter) {
        return null;
    }

    const shouldContinueBtnDisable =
        continueDisabled || isContinueBtnLoading || isPending;

    return (
        <div className="footer">
            {/* Stepper Component */}
            {/* {(!shouldHideBackButton || !shouldHideContinueButton) && (
        <div className="stepper">
          {[...Array(TOTAL_SECTION)].map((_, index) => (
            <div
              key={index}
              style={{ background: calculateBackground(index) }}
            ></div>
          ))}
        </div>
      )} */}
            <div className="footer_btn">
                <Button
                    onClick={() => {
                        handleFooterNextButtonText(t("continue"));
                        navigate(-1);
                    }}
                    className="footer_btn-back"
                >
                    {t("back")}
                </Button>
                {disabledTooltip ? <Popup
                    content={disabledTooltip}
                    inverted
                    on='click'
                    trigger={
                        <Button
                            className={
                                shouldContinueBtnDisable
                                    ? "footer_btn-start-disabled"
                                    : "footer_btn-start"
                            }
                            onClick={async () => {
                                if (shouldContinueBtnDisable) return;
                                trackSFOSteps();
                                handleNext();
                            }}
                        >
                            <div className="btn__content">
                                {footerNextButtonText}
                                {isContinueBtnLoading && (
                                    <Image
                                        className="footer__btn-animation"
                                        src={animationsRegistry[subDomain]}
                                    />
                                )}
                            </div>
                        </Button>} /> : <Button
                        className={
                        shouldContinueBtnDisable
                        ? "footer_btn-start-disabled"
                        : "footer_btn-start"
                    }
                    onClick={async () => {
                        if (shouldContinueBtnDisable) return;
                        trackSFOSteps();
                        handleNext();
                    }}
                >
                    <div className="btn__content">
                        {footerNextButtonText}
                        {isContinueBtnLoading && (
                            <Image
                                className="footer__btn-animation"
                                src={animationsRegistry[subDomain]}
                            />
                        )}
                    </div>
                </Button>}
            </div>
        </div>
    );
};

export default Footer;
